<template>
  <div class="container" @click='handleGallaryClick'>
    <div class="warpper">
      <swiper :options='swiperOptions'>
      <!-- slides -->
        <swiper-slide v-for="(item, index) in imgs" :key="index">
          <img class="gallary-img" :src="item"/>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonGallary',
  props: {
    imgs: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      swiperOptions: {
        pagination: '.swiper-pagination',
        paginationType: 'fraction',
        observeParents: true,
        observer: true
      }
    }
  },
  methods: {
    handleGallaryClick () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .container >>> .swiper-pagination
    overflow inherit
  .container
    display flex
    flex-direction column
    justify-content center
    position fixed
    z-index 99
    top 0
    left 0
    right 0
    bottom 0
    background #000
    .warpper
      width 100%
      height 0
      padding-bottom 56.25%
      .gallary-img
        width 100%
      .swiper-pagination
        color #fff
</style>



// WEBPACK FOOTER //
// src/common/gallary/Gallary.vue